import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject, BehaviorSubject, forkJoin } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ApiRequestService, LookupDataService } from '../../http'
import { AppMetadataHandler } from '../../../configs'
import { I18nService } from '../i18n/i18n.service'
import { ArrayManipulations, CommonUtilty } from '../../utilities';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
declare var OpenCC: any;
@Injectable({ providedIn: 'root' })
export class MultiLingualService {

    constructor(private apiRequest?: ApiRequestService,
        private lookupDataService?: LookupDataService,
        private appMetadataHandler?: AppMetadataHandler,
        private translateService?: TranslateService,
        private i18nService?: I18nService,
        private arrayManipulations?: ArrayManipulations,
        private commonUtility?: CommonUtilty,
        private http?: HttpClient
    ) { }

    // defaultLanguage = this.userInfoService.getUserInfo().languageCd ? this.userInfoService.getUserInfo().languageCd : 'EN';  
    defaultLanguage = 'EN';
    public englishLabelsArray = []
    public bahasaLabelsArray = []
    public enKeyLabels = {}
    supportedLanguages
    public listOfLocales = []
    public localeMap = {}
    defaultLanguageLoaded = false;
    private languageSource = new BehaviorSubject('default message');
    currentLanguageLoaded = this.languageSource.asObservable();

    public setDefaultLanguage(lang) {

        this.defaultLanguage = lang;
        this.fetchLabels(this.defaultLanguage)
        //API Call for fetching labels and setting it to Label array only if the old default language and new default language is different.
        //Also apply loader with msg 'Fetching selected language labels'

    }

    localeDO = {
        languageCd: null,
        labels: null
    }


    public fetchDefaultLanguage() {

        return this.defaultLanguage;
    }

    emitLanguage(lang: string) {
        this.languageSource.next(lang)
    }

    getAllLookups() {

        let lookupArr = ["languageCd"];
        let observables = new Array();
        for (let item of lookupArr) {
            observables.push(this.lookupDataService.getLookup(item));
        }

        forkJoin(observables).subscribe(
            res => {
                let response: any[] = res;

                for (let lookupList of response) {
                    if (lookupList[0].lookupCd == "languageCd") {
                        this.appMetadataHandler.supportedLanguages = lookupList
                    }
                }
            },
            error => console.log('Error: ', error)
        );
    }


    setLanguage(language: string) {
        this.i18nService.language = language;
    }

    setLanguageForLazyLoadedComponents(translateService) {
        translateService.use(this.i18nService.language);
    }

    get currentLanguage(): string {
        return this.i18nService.language;
    }

    get languages(): string[] {
        return this.i18nService.supportedLanguages;
    }

    fetchAllLabels(supportedLanguages: Array<any>, isThread?) {
        let lookupArr = supportedLanguages;
        let observables = new Array();
        let url = 'findByLanguageCd'
        for (let item of lookupArr) {
            let pathVariables = [];
            pathVariables.push(item);
            observables.push(this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables));
        }

        forkJoin(observables).subscribe(
            res => {
                let responses: any[] = res;
                this.defaultLanguageLoaded = false;
                for (let response of responses) {
                    if (response && response.length > 0) {
                        var locale = JSON.parse(JSON.stringify(this.localeDO))
                        locale.languageCd = response[0].language
                        locale.labels = this.transformForNGXTranslate(response)
                        console.log(JSON.stringify(locale.labels))
                        this.translateService.setTranslation(locale.languageCd, locale.labels);
                        this.listOfLocales.push(locale);
                        this.localeMap[locale.languageCd] = JSON.parse(JSON.stringify(locale.labels));
                        this.broadcastDefaultLanguageLoaded(locale.languageCd)
                    }
                }


                if (this.appMetadataHandler.localLocaleAllowed) {

                    this.appMetadataHandler.supportedLanguages.push('en-US')
                    this.translateService.setTranslation('en-US', this.i18nService.enUS);
                    this.appMetadataHandler.supportedLanguages.push('in-BH')
                    this.translateService.setTranslation('in-BH', this.i18nService.inBH);
                }
                this.listOfLocales = this.arrayManipulations.getUniqueElements(this.listOfLocales, 'languageCd')
            },
            error => console.log('Error: ', error)
        );
    }

    fetchLanguage(language?) {
        let me = this;
        let languageSubject = new BehaviorSubject<any>(1); // Will use this subject to emit data that we want
        let filtered = this.listOfLocales.filter(item => item.languageCd === language)

        if (language === me.appMetadataHandler.defaultLanguage) {
            languageSubject.next(language); // incidentList is a Subject and emits an event thats being listened to by the components
        }

        return languageSubject;
    }

    broadcastDefaultLanguageLoaded(lang) {
        if (lang === this.appMetadataHandler.defaultLanguage) {
            this.emitLanguage(lang)
        }
    }

    init() {
        //this.fetchLabels(this.appMetadataHandler.defaultLanguage, true)
    }

    fetchLabels(langCd?, isThread?) {
        // let language = null;
        // if (langCd != null) {
        //     language = langCd;
        // }
        // else {
        //     language = this.defaultLanguage;
        // }

        // this.englishLabelsArray = []
        // this.bahasaLabelsArray = []
        // let url = 'labelData/findByLanguageCd/'
        // if (environment.serverHost === 'mms-uat.sompo.co.id') {
         
        //     url = 'labelData/fetchAll/portal/'
        // }
        // this.apiRequest.get(url + language)
        //     .subscribe(jsonResp => {
        //         let res = Object.assign([], jsonResp)
        //         for (var i = 0; i < res.length; i++) {
        //             if (res[i].language == 'EN') {
        //                 this.englishLabelsArray.push(res[i]);
        //                 this.enKeyLabels[res[i].labelKey] = res[i].labelValue
        //             } else {
        //                 this.bahasaLabelsArray.push(res[i]);
        //             }
        //         }

        //         if (isThread) {
        //             this.fetchAllLabels(this.appMetadataHandler.supportedLanguages, true)
        //         }
        //     });
    }

    resetLanguageLocales(translateServiceInstance) {
        this.listOfLocales.forEach(locale => {
            translateServiceInstance.setTranslation(locale.languageCd, locale.labels);
        })
        translateServiceInstance.use(this.currentLanguage)
    }

    getTranslatedLabel(label, languageCd) {
        if (this.localeMap && this.localeMap[languageCd] && this.localeMap[languageCd][label]) {
            return this.localeMap[languageCd][label]
        }
        else
            return label
    }

    transformForNGXTranslate(LabelArray) {
        var returnObject = {}

        if (this.englishLabelsArray != null && LabelArray) {
            var allLabelKeys = Object.keys(this.enKeyLabels);

            allLabelKeys.forEach(labelName => {
                var englishKey = this.enKeyLabels[labelName]

                var otherLanguageObject = LabelArray.filter(label => {
                    return label.labelKey === labelName;
                })


                if (otherLanguageObject.length > 0) {
                    returnObject[englishKey] = otherLanguageObject[0].labelValue
                    if (this.appMetadataHandler.showLanguageLabel) {
                        returnObject[englishKey] = otherLanguageObject[0].labelValue + "-" + otherLanguageObject[0].language
                    }
                }
                else {
                    returnObject[englishKey] = englishKey
                    if (this.appMetadataHandler.showLanguageLabel) {
                        returnObject[englishKey] = englishKey + "-" + LabelArray[0].language
                    }
                }
            })
        }

        return returnObject
    }

    public getLabel(labelName) {
        var labelItemArray = []
        if (this.defaultLanguage === 'EN') {
            labelItemArray = this.englishLabelsArray.filter(label => {
                return label.labelKey === labelName;
            })
        } else
        //  if (this.defaultLanguage === 'ID') 
        {
            labelItemArray = this.bahasaLabelsArray.filter(label => {
                return label.labelKey === labelName;
            })
        }

        if (labelItemArray.length > 0)
            return labelItemArray[0].labelValue;
        else
            return 'Loading..'
    }

    //Traditional to Simple Chinese
    public ConvertChineseT2S(dataToConvert) {
        let converter = OpenCC.Converter({ from: 'hk', to: 'cn' });
        let output = converter(dataToConvert)
        return output
    }


    //Simple to Traditional Chinese
    public ConvertChineseS2T(dataToConvert) {
        let converter = OpenCC.Converter({ from: 'cn', to: 'hk' });
        let output = converter(dataToConvert)
        return output
    }

    generateInsightsFromRuleOutput(data){
        let translateResponse = new Subject<any>();
        const headers = { 'Content-Type': 'application/json' };
        const body = data;
    
        let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/meta-gpt/generateInsightsFromRuleOutput'
        this.http.post<any>(URL, body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtility.deepCopy(jsonResp);
                translateResponse.next(returnObj);
            },err => {
                translateResponse.next(err);
            });
        return translateResponse;
      }

    generateMedicalSummary(data) {
        let generateSummary = new Subject<any>();
        const headers = { 'Content-Type': 'application/json' };
        const body = data;

        let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/vision-intelligence/medicalReportSummary';
        this.http.post<any>(URL, body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtility.deepCopy(jsonResp);
                generateSummary.next(returnObj);
            }, err => {
                generateSummary.next(err);
            });
        return generateSummary;
    }
    
    generateSummaryForUnderwriting(data) {
        let generateSummary = new Subject<any>();
        const headers = { 'Content-Type': 'application/json' };
        const body = data;

        let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/meta-gpt/underWriterSummarizer';
        this.http.post<any>(URL, body, { headers })
            .subscribe(jsonResp => {
                let returnObj = this.commonUtility.deepCopy(jsonResp);
                generateSummary.next(returnObj);
            }, err => {
                generateSummary.next(err);
            });
        return generateSummary;
    }


}
